<template>
	<Modal v-model="show">
		<h2>About <em>ok</em>HiQ</h2>
		<p>
			<em>ok</em>HiQ invites you to submit ideas through photos, drawings and
			text on a variety of topics. You can also vote on your favourites and view
			a running leader board to see which ideas receive the most votes. Each
			voting round shows a random selection of submissions. To view more
			submissions, play again!
		</p>
		<p>
			Topics range from feedback for HiQ or other areas within QUT, to
			light-hearted topics like favourite pets.
		</p>
		<p>
			Your submissions are moderated before being displayed on our campus
			digital screens and the <em>ok</em>HiQ web pages along with your chosen
			display name. Submissions may also be used in future HiQ campaigns as
			outlined in our terms and conditions.
		</p>
		<p>
			You can remain anonymous but you need to provide contact details to win in
			a prize round. All data is collected and managed in line with our
			<a
				target="_blank"
				href="http://www.mopp.qut.edu.au/F/F_06_02.jsp"
				rel="noreferrer noopener"
				>Information privacy statement</a
			>.
		</p>
		<p>
			Please
			<a
				target="_blank"
				href="https://www.qut.edu.au/about/contact/h/hiq"
				rel="noreferrer noopener"
				>contact HiQ</a
			>
			with any queries or concerns.
		</p>
	</Modal>
</template>

<script>
import Modal from '@/components/main/Modal'

import modal from '@/mixins/modal'
const modalAbout = modal('about')

export default {
	name: 'ModalAbout',
	mixins: [modalAbout],
	components: { Modal }
}
</script>
